import notification from 'services/notification';
import chatttSDK from 'services/chattt';
import focusChatttClient from 'utils/focusChatttClient';
import { tolgee } from 'services/i18n/tolgee';

const createOfflineNotify = (notify: (count: number) => void, delay: number = 1000) => {
  let count = 0;
  let timer: NodeJS.Timeout;

  const offlineNotify = (num: number) => {
    clearTimeout(timer);

    count += num;

    if (count === 0) {
      return;
    }

    timer = setTimeout(() => {
      notify(count);

      count = 0;
    }, delay);
  };

  return offlineNotify;
};

export const offlineNotify = createOfflineNotify((count) => {
  notification.notify(
    {
      title: tolgee.t('nim.您有x条新消息', { x: count }),
      content: tolgee.t('nim.请及时处理', ''),
      id: 'fakeMessageId',
      conversationId: 'fackConversationId',
    },
    {
      onClick: () => {
        focusChatttClient();
      },
    },
  );

  if (chatttSDK?.emitter?.emit) {
    chatttSDK?.emitter.emit('new_message', {});
  }
});
